import { Redirect, useLocation } from 'react-router-dom';
import { buildLoginRedirectPath } from 'src/utils/url';

export default function RedirectToLogin() {
  const { pathname, search } = useLocation();

  return <Redirect to={buildLoginRedirectPath(pathname, search)} />;
}
